export interface DownloadDeviceFlags {
    inAndroid: boolean
    inIOS: boolean
    inMobile: boolean
}

export interface DownloadPlatformGuard {
    allow: boolean
    targetOsType: number
    message?: string
}

const OS_TYPE_IOS = 1
const OS_TYPE_ANDROID = 2
const OS_TYPE_IOS_APPSTORE = 3
const OS_TYPE_WINDOWS = 5

export function resolveDownloadTargetOsType(device: DownloadDeviceFlags, landingPackageOsType?: number): number {
    if (!device.inMobile && landingPackageOsType === OS_TYPE_WINDOWS) return OS_TYPE_WINDOWS
    if (device.inAndroid || !device.inMobile) return OS_TYPE_ANDROID
    return OS_TYPE_IOS
}

export function getLandingMaterialOsTypePriority(device?: DownloadDeviceFlags): Array<number> {
    if (device && !device.inMobile) return [OS_TYPE_WINDOWS, OS_TYPE_ANDROID, OS_TYPE_IOS]
    return [OS_TYPE_ANDROID, OS_TYPE_IOS]
}

export interface OfficialCpsIosGuideOptions {
    inIOS: boolean
    inSafari: boolean
    inWechat: boolean
    inBaiduBox: boolean
    inQQ: boolean
    officialCpsChl: boolean
    routeName?: string | null
    osType: number
}

export function shouldShowOfficialCpsIosGuide(options: OfficialCpsIosGuideOptions): boolean {
    const { inIOS, inSafari, inWechat, inBaiduBox, inQQ, officialCpsChl, routeName, osType } = options

    if (!inIOS || !officialCpsChl || routeName !== 'download') return false
    if (![OS_TYPE_IOS, OS_TYPE_IOS_APPSTORE].includes(osType)) return false

    return inWechat || inBaiduBox || inQQ || !inSafari
}

export function getDownloadPlatformGuard(device: DownloadDeviceFlags, packageOsType?: number): DownloadPlatformGuard {
    const targetOsType = resolveDownloadTargetOsType(device, packageOsType)

    if (!device.inMobile) {
        if ([OS_TYPE_WINDOWS, OS_TYPE_ANDROID].includes(packageOsType as number)) {
            return { allow: true, targetOsType }
        }
        return { allow: false, targetOsType, message: '当前系统暂无Windows或安卓安装包' }
    }

    if (targetOsType === OS_TYPE_ANDROID) {
        if (packageOsType === OS_TYPE_ANDROID) return { allow: true, targetOsType }
        return { allow: false, targetOsType, message: '当前系统暂无安卓安装包' }
    }

    if ([OS_TYPE_IOS, OS_TYPE_IOS_APPSTORE].includes(packageOsType as number)) return { allow: true, targetOsType }

    return { allow: false, targetOsType, message: '当前系统暂无iOS安装包' }
}
